import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ICompany } from '@myapp/features/admin/models';
import { AdminService } from '@myapp/features/admin/services';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DropDownListModule } from '@progress/kendo-angular-dropdowns';
import {  ExcelModule, GridModule } from '@progress/kendo-angular-grid';
import { TextBoxModule } from '@progress/kendo-angular-inputs';
import { v4 as uuidv4 } from 'uuid';
import { BaseGridComponent } from '../../base-grid/base-grid.component';
import { CompaniesEditorComponent } from '../companies-editor/companies-editor.component';
import { CompanyForm } from '../companies-editor/company.form';
import { CompanyFilter } from './company.filter';

@Component({
  selector: 'app-companies',
  templateUrl: './companies.component.html',
  styleUrls: ['./companies.component.scss'],
  standalone: true,
  imports: [GridModule, TextBoxModule,  ExcelModule,  DropDownListModule, FormsModule, CompaniesEditorComponent]
})


export class CompaniesComponent extends BaseGridComponent<ICompany> {

  constructor(adminService: AdminService, modalService: NgbModal) {
    super(adminService, modalService);
    this.filter = new CompanyFilter();
  }

  retrieveItems(): void {
    this.retrieveCompanies();
  }

  retrieveCompanies(): void {
    this.adminService.getAllCompanies()
      .subscribe(
        data => {
          this.items = data;
          this.filteredItems = this.items;
          this.loadItems();
        });
  }

  refreshItems(): void {
    this.retrieveCompanies();
  }

  saveItem(item: ICompany, isNew: boolean): void {
    this.adminService.saveCompany(item, isNew)
      .subscribe(
        _response => {
          this.refreshItems();
        },
        error => {
          // Raise Error
          console.error(error);
        });
  }


  public addHandler({ sender }: any) {

    var company: ICompany = {
      id: uuidv4(),
      name: "New Company",
      description: "",
      isActive: false
    };

    const size = 'lg';
    const options = {
      title: "Add Company", windowClass: "modal-preferences",
      showSave: true, showCancel: true, showCross: true, scrollable: false, saveText: 'Add'
    };

    this.showEditorModal(size, options, CompaniesEditorComponent, new CompanyForm(company), true);
  }

  public editHandler({ sender, rowIndex, dataItem }: any) {
    const size = 'lg';
    const options = {
      title: "Edit Company", windowClass: "modal-preferences",
      showSave: true, showCancel: true, showCross: true, scrollable: false
    };

    this.showEditorModal(size, options, CompaniesEditorComponent, new CompanyForm(dataItem), false);
  }

  public removeHandler({ dataItem }: any): void {
    this.adminService.removeCompany(dataItem)
      .subscribe(
        _response => {
          // Only close row on success, otherwise flag the error          
          this.refreshItems();
        },
        error => {
          // Raise Error
          console.error(error);
        });
  }

}
